module.exports = __webpack_public_path__ + "img/corner_down.552c2b7f.gif";